module.exports = __webpack_public_path__ + "img/form_doc.d56f4f1a.svg";